import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { isLoaded, isEmpty } from 'react-redux-firebase';
import propTypes from 'prop-types';
import { LOGIN } from '../constants/routes';
function PrivateRoute({ children, admin, organizationAdmin, subsidiaryAdmin, ...rest }) {
  const auth = useSelector((state) => state.firebase.auth);
  const profile = useSelector((state) => state.firebase.profile);

  let canAccess = false;
  if (profile.isLoaded) {
    const roles = profile.claims || [];
    canAccess =
      (!admin && !organizationAdmin && !subsidiaryAdmin) ||
      (admin && roles.includes('admin')) ||
      (organizationAdmin && roles.includes('organizationAdmin'));
  } else {
    canAccess = false;
  }
  return (
    <Route
      {...rest}
      render={({ location }) => {
        if (canAccess && isLoaded(auth) && !isEmpty(auth)) return children;
        else {
          return (
            <Redirect
              to={{
                pathname: LOGIN,
                state: { from: location },
              }}
            />
          );
        }
      }}
    />
  );
}

const Props = {
  children: propTypes.element,
  admin: propTypes.bool,
  organizationAdmin: propTypes.bool,
  subsidiaryAdmin: propTypes.bool,
};

PrivateRoute.propTypes = Props;

export default PrivateRoute;
